import { render } from "./CaseStages.vue?vue&type=template&id=9530adf2&scoped=true"
import script from "./CaseStages.vue?vue&type=script&lang=js"
export * from "./CaseStages.vue?vue&type=script&lang=js"

import "./CaseStages.vue?vue&type=style&index=0&id=9530adf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9530adf2"]])

export default __exports__